import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'forest' | 'earth' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-gold text-forestDeep shadow-[0_10px_26px_rgba(201,147,26,.34)] hover:bg-goldDark hover:text-white',
    forest: 'bg-forest text-white shadow-[0_10px_26px_rgba(18,48,26,.30)] hover:bg-forestDeep',
    earth: 'bg-earth text-white shadow-[0_10px_26px_rgba(122,82,48,.30)] hover:bg-earthDark',
    outline: 'border-2 border-gold bg-transparent text-goldLight hover:bg-gold hover:text-forestDeep'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 rounded-lg font-extrabold uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-257" data-mp="om96oozf7afc">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-258" data-mp="12l8s7nrmz97a" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-259" data-mp="xmfouo62cyku">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="17ebo42jvyuqn" />}
    </button>;
}